module.exports = __webpack_public_path__ + "img/grid.53b05f4b.png";